import type { PermissionCode } from '@/constants/permissions';
import { ROUTES } from '@/constants/routes';

export const clearUser = () => {
  localStorage.clear();
  sessionStorage.clear();
};

/** Tizimdan chiqish. Sahifa to'liq qayta yuklanadi, shuning uchun xotirada
 *  oldingi foydalanuvchidan hech narsa qolmaydi — react-query keshi ham,
 *  store'lar ham nolga tushadi. `replace` — "orqaga" bilan qaytib bo'lmaydi. */
export const logout = () => {
  clearUser();
  window.location.replace(ROUTES.AUTH);
};

export const setUser = async <T>(islocalStorage: boolean, data: T) => {
  const user = JSON.stringify(data);
  if (islocalStorage) {
    localStorage.setItem('userData', user);
  } else {
    sessionStorage.setItem('userData', user);
  }
};

export const getUser = () => {
  const userString = localStorage.getItem('userData');
  if (!userString) return null;

  try {
    const user = JSON.parse(userString);

    if (user?.session_expires_at) {
      const expiresAt = new Date(user.session_expires_at).getTime();
      const now = Date.now();

      if (now >= expiresAt) {
        localStorage.removeItem('userData');
        return null;
      }
    }

    return user;
  } catch (e) {
    localStorage.removeItem('userData');
    return null;
  }
};

export const hasPermission = (
  userPermissions: string[],
  permission: PermissionCode,
): boolean => {
  return userPermissions.includes(permission);
};
